import { Fragment } from "react";
import {
  BrowserRouter as Router,
  Redirect,
} from "react-router-dom";
import CoinsCNT from "fixtureData/coins/index";
import { useTranslation } from "react-i18next";
import Slider from "react-slick";
import { Helmet } from 'react-helmet';
import TreadingBox from "components/pages/web/static/treadingBox";
import CoinInformation from "components/pages/web/static/coinInformation";
import CoinQuestions from "components/pages/web/static/coinQuestions";
import { Col, Container, Row, Card, CardBody } from "reactstrap";
import CoinBoxBlog from "components/pages/web/static/coinBoxBlog";
import { SETTINGS_THREE_ITEM } from "constants/sliderSetting";
import { camelize } from 'utils/transformer';
import "slick-carousel/slick/slick.scss";
import "slick-carousel/slick/slick-theme.css";

const CoinDynamicRoute = (props) => {

  const { t } = useTranslation();
  const pureCoinSlug = props.match.params.id;
  const currentToken = camelize(pureCoinSlug);
  const currentCoinInfo = CoinsCNT[currentToken];
  const settings = SETTINGS_THREE_ITEM;
  const sliderItems=[
    {heroTitle:"Analysis and investment",
    content:"Read Technical Analysis, Engin Analysis and Fundamental Analysis of Digital Currencies here.",
    link:"https://blog.coinnik.market/category/analysis-investing/",time:""},
    {heroTitle:"Introduction of digital currencies",content:"Read more about the history of digital currencies and their network here.",link:"https://blog.coinnik.market/category/review/cryptocurrencies/ ",time:""},
    {heroTitle:"Technical analysis training",content:"If you want to learn technical analysis, visit this page.",link:"https://blog.coinnik.market/category/analysis-investing/technical-analysis/ ",time:""},
  ]
   const boxSlider=()=>(
    sliderItems.map((item) => (
    <Col xs="12"  lg="4" xl="4"  className="d-flex pt-5 pb-5  px-2 ">
      <Card className="shadow border-radius-1 " style={{
        height:190
      }} >
        <CardBody>
          <CoinBoxBlog
            heroTitle={t(item.heroTitle)}
            content={t(item.content)}
            link={t(item.link)}
            time={t(item.time,{ number: "۲ "})}
         />
        </CardBody>
      </Card>
   </Col>
    ))
)
  return (
    <Fragment>
      <TreadingBox coinName={pureCoinSlug} informationTitle={ currentCoinInfo.informationTitle} />  
      <Helmet>
        <title>{t(currentCoinInfo.meta.title)}</title>
        <meta name="description" content={t(currentCoinInfo.meta.description)} />
        <meta name="keywords" content={t(currentCoinInfo.meta.keywords)}  />   
        {currentCoinInfo.scripts &&
          <script type="application/ld+json">
              {JSON.stringify(currentCoinInfo.scripts)} 
          </script>
        }
      </Helmet>
      {currentCoinInfo && currentCoinInfo.body.length ? (
        currentCoinInfo.body.map((item) => (
            <Container className="pt-3 pb-2">
              <Row>
                <Col xs="12">
                  <Card className="shadow border-radius-1 pt-3 pb-4">
                    <CardBody>
                    {item.map((coin) => (
                      <CoinInformation
                        heroTitle={t(coin.heroTitle)}
                        subTitle={t(coin.subTitle)}
                        content={t(coin.content)}
                        btnTitle={t(coin.btnTitle)}
                        linkTitle={t(coin.linkTitle)}
                        props={props}
                      />
                    ))}
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
        ))
      ) : (
        <Redirect to="/404" />
      )}
       {currentCoinInfo && currentCoinInfo.faq.length && (
         <Container className="pt-3 pb-3">
              <Row>
                <Col xs="12">
                  <Card className="shadow border-radius-1 ">
                    <CardBody>
                    <CoinQuestions questionsArray={currentCoinInfo.faq}  />
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          )}
          
        <Container className="pt-5">
          <Row>
            <Col xl="12" className="text-center text-secondary-seven-light fs-5 pb-3">
             <span>{t(currentCoinInfo.blogTitle)} </span> 
            </Col>
          </Row>
         <Row className="overflow-hidden">
          <Slider {...settings}>
            { boxSlider()}
          </Slider>
      </Row>
     </Container>
    </Fragment>
  );
};

export default CoinDynamicRoute;
